import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { InputAdornment } from '@mui/material';
import { Phone } from '@mui/icons-material';

import MaskedPhone from '../MaskedPhone';
import { TRACKING_CONTEXTS } from '../../constants/trackingContexts';

const paths = {
  tel1: ['tel1'],
  tel2: ['tel2'],
  tel3: ['tel3']
};

const telIconAdornment = {
  startAdornment:
    <InputAdornment position="start">
      <Phone fontSize="small" />
    </InputAdornment>
};

const Tels = ({ setData, tel1, tel2, tel3 }) =>
  <Grid container key="1" spacing={3}>
    <MaskedPhone
      key="tel1"
      number={tel1}
      editable={true}
      entityType="billing"
      context={TRACKING_CONTEXTS.EDIT_BILLING}
      grid
      xs={12}
      sm={4}
      lg={3}
      capsLocked
      searchPhone
      label="Téléphone 1"
      path={paths.tel1}
      setData={setData}
      id='tel1'
      autoComplete="off"
      InputProps={{ ...telIconAdornment }}
    />
    <MaskedPhone
      key="tel2"
      number={tel2}
      editable={true}
      entityType="billing"
      context={TRACKING_CONTEXTS.EDIT_BILLING}
      grid
      xs={12}
      sm={4}
      lg={3}
      capsLocked
      label="Téléphone 2"
      path={paths.tel2}
      setData={setData}
      id='tel2'
      autoComplete="off"
      InputProps={{ ...telIconAdornment }}
    />
    <MaskedPhone
      key="tel3"
      number={tel3}
      editable={true}
      entityType="billing"
      context={TRACKING_CONTEXTS.EDIT_BILLING}
      grid
      xs={12}
      sm={4}
      lg={3}
      capsLocked
      label="Téléphone 3"
      path={paths.tel3}
      setData={setData}
      id='tel3'
      autoComplete="off"
      InputProps={{ ...telIconAdornment }}
    />
  </Grid>;

Tels.propTypes = {
  tel1: PropTypes.string.isRequired,
  tel2: PropTypes.string.isRequired,
  tel3: PropTypes.string.isRequired,
  setData: PropTypes.func.isRequired
};

Tels.defaultProps = {
  tel1: '',
  tel2: '',
  tel3: ''
};

export default Tels;
